import React from "react";
import axios from 'axios';
import ReactTable from 'react-table-v6'
import '../../assets/css/Table.css'
import { withStyles } from '@material-ui/core/styles';
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Grid from '@material-ui/core/Grid';
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import CardHeader from "../Card/CardHeader.jsx";
import { cardTitle } from "../../assets/jss/material-dashboard-pro-react.jsx";
import { NavLink } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from 'moment';
import Search from '../../assets/img/search_icon2x.png'
import RegularButton from "../CustomButtons/Button";
import Reset from '../../assets/img/icons8-delete-26.png'
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Datetime from 'react-datetime';
import ExportTo from '../Common/ExportTo'
import CustomSelect from '../Common/CustomSelect'
import CustomDialog from '../Common/CustomDialog'
import { BASE_URL } from '../../utils/handleApi'

const styles = theme => ({
	button: {
		marginLeft: "10px",
		color: 'white',
		backgroundColor: '#04ab23',
		textTransform: 'none',
		fontFamily: 'Roboto-Medium',
		boxShadow: "none",
		borderRadius: 1,
		width: '100px',
		fontSize: "17px",
		'&:hover': {
			backgroundColor: '#04ab23'
		},
		'&:focus': {
			outline: 'none',
			backgroundColor: '#04ab23'
		},
	},

	select: {
		width: '12vw',
		height: "26px",
		border: 'none',
		boxShadow: '0px 0px 5px 0px #d6d6d6',
		// [theme.breakpoints.down('xs')]: {
		//   width: '40vw',

		// },
		},
	cardIconTitle: {
		...cardTitle,
		marginTop: "10px",
		[theme.breakpoints.down('xs')]:{
				marginTop:"25%"
		}
	},
	headerBlock: {
		alignItems: 'center',
		justifyContent: 'flex-end',
		[theme.breakpoints.down('md')]:{
			justifyContent: 'center'
		}
	}
});
class ReactTables extends React.Component {
	state = {
		transactions: [],
		loading: false,
		search_text: '',
		search_type: '',
		originalTable: [],
		filterApplied: false,
		search_field_type: "text",
		month_filter: '',
		month_filter_applied: false,
		openDialogWhenNoData: false
	};
	
	componentDidMount() {
		this.setState({ loading: true })
		const tokenStr = localStorage.getItem('token')
		axios.post(`${BASE_URL}/order/allTransactions`,{},{
			headers: {
			  'Authorization': `Bearer ${tokenStr}`
			}
		  })
		.then(res => {
			res.data.reverse();
			this.setState({ transactions: res.data, loading: false, originalTable: res.data });
		})
		.catch(err => {
			this.setState({ loading: false });
		})
	  }

		handleChange = e => {
			if(e.target.value.includes("date")){
				this.setState({ search_field_type: 'date', search_text: moment().format('MM/DD/YYYY')})
			} else {
				this.setState({ search_field_type: 'text', search_text: ''})
			}
			this.setState({ [e.target.name]: e.target.value })
		}
	
		searchTable = () => {
			let { search_text, search_type } = this.state;
			let tokenStr = localStorage.getItem("token");
			const body = {
				key_name: search_type,
				search_text: search_text.trim()
			}
			this.setState({ loading: true })
			axios.post(`${BASE_URL}/order/searchTransaction`, body, {
				headers: {
					Authorization: `Bearer ${tokenStr}`,
				},
			})
			.then((res) => {
				if(search_type === 'order_no' || search_type === 'order_date' || search_type === 'completed_date'){
					const removeFalsyOrderId = res.data.filter(transaction => transaction.order_id !== null)
					return this.setState({ loading: false, transactions: removeFalsyOrderId, filterApplied: true, })
				}
				if(search_type === 'lender'){
					const removeFalsyLender = res.data.filter(transaction => transaction.lender_id !== null)
					return this.setState({ loading: false, transactions: removeFalsyLender, filterApplied: true, })
				}
				if(search_type === 'product'){
					const removeFalsyProduct = res.data.filter(transaction => transaction.product_id !== null)
					return this.setState({ loading: false, transactions: removeFalsyProduct, filterApplied: true, })
				}
				this.setState({ loading: false, transactions: res.data, filterApplied: true, });
			})
			.catch(err => {
				this.setState({ loading: false })
			})
		}

		resetFilter = () => {
			const { originalTable } = this.state;
			this.setState({ 
				transactions: originalTable,
				search_text: "",
				search_type: "",
				filterApplied: false,
				search_field_type: 'text'
			})
		}

		handleMonthChange = e => {
			const { originalTable, transactions } = this.state;
			this.setState({
				month_filter: e.target.value,
				transactions: originalTable
			},() => {
					const { month_filter } = this.state;
					this.setState({
						transactions: transactions.filter(transaction => moment(transaction.transaction_date).month() === +month_filter),
						month_filter_applied: true,
					})
			})
		}

		resetMonthFilter = () => {
			const { originalTable } = this.state;
			this.setState({ 
				transactions: originalTable,
				month_filter: '',
				month_filter_applied: false
			})
		}

		exportPDF = () => {
			const { transactions, originalTable, openDialogWhenNoData } = this.state;
      if(transactions.length === 0){
        return this.setState({ openDialogWhenNoData: !openDialogWhenNoData })
      }
      else {
				const unit = "pt";
				const size = "A4";
				const orientation = "landscape";
			
				const marginLeft = 20;
				const doc = new jsPDF(orientation, unit, size);
			
				doc.setFontSize(15);
			
				const title = "My Transactions";
				const headers = [[ "Order No", 
					"Lender Name", 
					"Product Name",
					"Order Date", 
					"Order Completion Date", 
					"Fee", ]];
			
				const data = (transactions.length < originalTable.length ? transactions : originalTable).map((prop, key) => ([
					prop.order_id?.order_no,
					prop.lender_id?.name,
					prop.product_id?.name || "N/A",
					prop.order_id?.order_date,
					moment(prop.transaction_date).format('MM/DD/YYYY'),
					prop.cost || "0",
				]))
			
				let content = {
					startY: 50,
					head: headers,
					body: data
				};
			
				doc.text(title, marginLeft, 40);
				doc.autoTable(content);
				doc.save(`transactions_${moment().format('LLL')}`)
			}
		}

		exportExcel = () => {
			if(this.state.transactions.length === 0){
				this.setState({ openDialogWhenNoData: !this.state.openDialogWhenNoData });
				return false
			}
		return true
		}

		render() {
			const { classes } = this.props;
			const { transactions, originalTable, filterApplied, loading, search_text, search_type, search_field_type, month_filter, month_filter_applied, openDialogWhenNoData } = this.state;
			const transactionsData = (transactions.length < originalTable.length ? transactions : originalTable).map((prop) => {
				return {
					order_no: prop.order_id?.order_no,
					lender_name: prop.lender_id?.name,
					product: prop.product_id?.name || "N/A",
					order_date: moment(prop.order_id?.order_date).format('MM/DD/YYYY'),
					completed_date: moment(prop.transaction_date).format('MM/DD/YYYY'),
					fee: `$${prop.cost || 0}`,
					attachments:  (<NavLink to={{
						pathname: `/Attachments/${prop.order_id && prop.order_id._id}`,
						state: { comp_order: true }}}
					style={{color:"#04ab23"}}>
					<p style={{textAlign: "center",textDecorationLine: 'underline'}}>View</p></NavLink>)
			}})

			const dataExcel = (transactions.length < originalTable.length ? transactions : originalTable).map((prop) => {
				return {
					"Order No.": prop.order_id?.order_no,
					"Lender Name": prop.lender_id?.name,
					"Product Name": prop.product_id?.name,
					"Order Date": prop.order_id?.order_date,
					"Order Completion Date": moment(prop.transaction_date).format('MM/DD/YYYY'),
					"Fee": `$${prop.cost || 0}`,
				};
			})

			const totalCost = transactions.filter(transaction => Object.keys(transaction).includes('cost')).reduce((acc, val) => acc + +val.cost, 0);

			return (
				<GridContainer>
					{originalTable.length > 0 && (
						<GridItem xs={12} md={12} style={{ justifyContent: 'flex-start', display: 'flex', }}>
							<h4 className={classes.textSearch}>Select Month</h4>
							<div style={{display: 'flex', alignItems: 'center', margin: '0 1rem'}}>
								<CustomSelect
									name={'month_filter'}
									disabled={month_filter_applied}
									value={month_filter}
									handleChange={this.handleMonthChange}
									options={[
										{name: 'Select Month', value: ''},
										{name: 'January', value: 0},
										{name: 'February', value: 1},
										{name: 'March', value: 2},
										{name: 'April', value: 3},
										{name: 'May', value: 4},
										{name: 'June', value: 5},
										{name: 'July', value: 6},
										{name: 'August', value: 7},
										{name: 'September', value: 8},
										{name: 'October', value: 9},
										{name: 'November', value: 10},
										{name: 'December', value: 11},
									]}
								/>
								{month_filter_applied && <IconButton aria-label="reset month filter" style={{color: "#eee", backgroundColor: "#e45252", padding: 0, margin: "6px 0 0 12px"}} onClick={this.resetMonthFilter}>
									<CloseIcon />
								</IconButton>}
							</div>
						</GridItem>
					)}
					<GridItem xs={12}>
						<Card>
							<CardHeader color="rose" icon>
								<div className={classes.cardIconTitle}>
									<Grid container>
										<Grid container item xs={12} md={8} className={classes.headerBlock}>
											<h4 style={{margin: "0 1rem 0 0"}}>Search By</h4>
											<CustomSelect
												name={'search_type'}
												disabled={filterApplied}
												value={search_type}
												handleChange={this.handleChange}
												options={[
													{name: 'Select Type', value: ''},
													{name: 'Order No', value: 'order_no'},
													{name: 'Lender', value: 'lender'},
													{name: 'Product', value: 'product'},
													{name: 'Order Date', value: 'order_date'},
													{name: 'Order Completed Date', value: 'completed_date'},
												]}
											/>
											<h4 style={{margin: "0 1rem"}}>Lookup</h4>
											{search_field_type === "text" && (
												<input 
													name="search_text"
													type="text"
													value={search_text}
													onChange={this.handleChange}
													id="search" 
													className={classes.select1}
													disabled={filterApplied || !search_type}
												/>
											)}
											{search_field_type === "date" && (
												<Datetime
													id="search"
													className="filter-date-picker"
													closeOnSelect
													timeFormat={false}
													value={search_text}
													initialValue={new Date()}
													onChange={event => {
														return this.setState({ search_text: event.format('MM/DD/YYYY')})
													}}
													inputProps={{
														disabled: filterApplied || !search_type
													}}
												/>
											)}
											<RegularButton
												onClick={filterApplied ? () => this.resetFilter() : () => this.searchTable()}
												disabled={!search_text}
												variant="contained"
												className={classes.button}
												style={filterApplied ? {backgroundColor: "#e45252"} : {}}
												endIcon={<img src={filterApplied ? Reset : Search} alt={filterApplied ? "Reset" : "Search"} style={{height: "20px", width: "20px"}} />}
												>
												{filterApplied ? 'Reset' : 'Search'}
											</RegularButton>
										</Grid>
										<Grid container item xs={12} md={4}>
											<ExportTo 
												fileName={'transactions'}
												exportPDF={this.exportPDF}
												exportExcel={this.exportExcel}
												dataExcel={dataExcel}
											/>
										</Grid>
									</Grid>
								</div>
									</CardHeader>
									<CardBody>
										<ReactTable
											loading={loading}
											NoDataComponent={() => !loading && <p style={{textAlign: "center"}}>{originalTable.length === 0 ? `No Transactions available` : `No data found`}</p>}
											data={transactionsData}
											columns={[
											{
												Header: "Order No.",
												accessor: "order_no",
												headerStyle: { border: 'none', fontFamily: 'Roboto-Light', color: '#333333' },
												style: { whiteSpace: 'unset', fontFamily: "Roboto-Regular", color: "#333333", fontSize: '12px' }
											},
											{
												Header: "Lender Name",
												accessor: "lender_name",
												headerStyle: { border: 'none', fontFamily: 'Roboto-Light', color: '#333333' },
												style: { whiteSpace: 'unset', fontFamily: "Roboto-Regular", color: "#333333", fontSize: '12px' }
											},
											{
												Header: "Product Name",
												accessor: "product",
												headerStyle: { border: 'none', fontFamily: 'Roboto-Light', color: '#333333', textAlign: 'left' },
												style: { whiteSpace: 'unset', fontFamily: "Roboto-Regular", color: "#333333", fontSize: '12px' }
											},
											{
												Header: "Order Date",
												accessor: "order_date",
												headerStyle: { border: 'none', fontFamily: 'Roboto-Light', color: '#333333', textAlign: 'left' },
												style: { whiteSpace: 'unset', fontFamily: "Roboto-Regular", color: "#333333", fontSize: '12px' }
											},
											{
												Header: "Order Completion Date",
												accessor: "completed_date",
												headerStyle: { border: 'none', fontFamily: 'Roboto-Light', color: '#333333', textAlign: 'left' },
												style: { whiteSpace: 'unset', fontFamily: "Roboto-Regular", color: "#333333", fontSize: '12px' }
											},
											{
												Header: "Attachments",
												accessor: "attachments",
												sortable: false,
												headerStyle: { border: 'none', fontFamily: 'Roboto-Light', color: '#333333', textAlign: 'center' },
												style: { whiteSpace: 'unset', fontFamily: "Roboto-Regular", color: "#333333", fontSize: '12px' }
											},
											{
												Header: "Fee",
												accessor: "fee",
												sortMethod: (a, b) => Number(a)-Number(b),
												headerStyle: { border: 'none', fontFamily: 'Roboto-Light', color: '#333333', textAlign: 'center' },
												style: { whiteSpace: 'unset', fontFamily: "Roboto-Regular", color: "#333333", fontSize: '12px', textAlign: 'center' }
											}
											]}
											style={{ width: '99%', border: 'none', whiteSpace: 'unset',}}
											defaultPageSize={10}
											minRows={0}
											showPaginationTop
											showPaginationBottom={false}
											className="-striped -highlight"
											getTrGroupProps={() => {
												return {
													style: {
														borderBottom: "1px solid #d6d6d6",
													}
												}
											}}
											getPaginationProps={() => { return { style: { boxShadow: 'none', border: 'none', } } }}
										/>
										{transactions.length > 0 && <p style={{margin: "1rem 0 0 0", fontWeight: "bold", textAlign: "right", marginRight: "80px"}}>{`TOTAL - $${totalCost}`}</p>}
									</CardBody>
							</Card>
					</GridItem>
					<CustomDialog 
            openDialog={openDialogWhenNoData}
            closeDialog={() => this.setState({ openDialogWhenNoData: !openDialogWhenNoData })}
          />
				</GridContainer>
			);
		}
}

export default withStyles(styles)(ReactTables);
